export default "__VITE_ASSET__CNpItakF__"